export const getLuckyDrawConfirmationCopy = hasExistingLuckyDraw => ({
  title: hasExistingLuckyDraw
    ? "Reset Lucky Draw"
    : "Generate Lucky Draw",
  body: hasExistingLuckyDraw
    ? "Are you sure you want to reset the lucky draw?"
    : "Are you sure you want to generate the lucky draw?",
  confirmLabel: hasExistingLuckyDraw
    ? "Yes, reset"
    : "Yes, generate",
  cancelLabel: "No",
})
